import { useTranslation, Link } from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as AnalyticsContext from "../../analytics/AnalyticsProvider.jsx";
import * as ClassNamesModule from "../../utils/classNames.js";
import { heroActions } from "../../content/hero.js";
import * as jsxRuntime from "react/jsx-runtime";
function HeroArrow({ stroke: e = "#fff" }) {
  return (
    <svg width={"14"} height={"14"} viewBox={"0 0 14 14"} fill={"none"}>
      <path
        d={"M1 7h11M9 4l3 3-3 3"}
        stroke={e}
        strokeWidth={"1.5"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
      />
    </svg>
  );
}
function HeroActions({ interactive: e = true, className: className }) {
  let { t: translate } = useTranslation(),
    { track: track } = (0, AnalyticsContext.useAnalytics)();
  return (
    <div
      className={(0, ClassNamesModule.cn)(
        "HeroButtons_heroButtons__nYLVb",
        className,
      )}
      data-hero-buttons={true}
    >
      {heroActions.map((t) => {
        var a;
        let r =
            "primary" === t.variant
              ? "HeroButtons_btnPrimary__nYLVb"
              : "HeroButtons_btnOutline__nYLVb",
          l = "primary" === t.variant ? "#fff" : "currentColor",
          s = translate(t.labelKey),
          c = (
            <jsxRuntime.Fragment>
              <span>{s}</span>
              <span className={"HeroButtons_arrow__nYLVb"}>
                <HeroArrow stroke={l} />
              </span>
            </jsxRuntime.Fragment>
          );
        if (!e)
          return (
            <span key={t.key} className={r}>
              {c}
            </span>
          );
        let d = () => {
          (track("track", t.legacyEvent),
            track("track", t.trackEvent, t.trackParams),
            t.bannerTrackEvent && track("track", t.bannerTrackEvent));
        };
        return (a = t.href).startsWith("/") && !a.startsWith("//") ? (
          <Link key={t.key} to={t.href} className={r} onClick={d}>
            {c}
          </Link>
        ) : (
          <a
            key={t.key}
            href={t.href}
            target={"_blank"}
            rel={"noopener noreferrer"}
            className={r}
            onClick={d}
          >
            {c}
          </a>
        );
      })}
    </div>
  );
}
export { HeroArrow, HeroActions };
